var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Center, Checkbox, FormControl, FormLabel, HStack, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Stack, useToast, VStack, Text, } from "@reverb-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context-api/providers/auth";
export var Cockpit = function (_a) {
    var onClose = _a.onClose, isOpen = _a.isOpen;
    var _b = useState(), emailToSimulate = _b[0], setEmailToSimulate = _b[1];
    var _c = useState(false), isAccepeted = _c[0], setIsAccepeted = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var loginWithCockpit = useContext(AuthContext).loginWithCockpit;
    var toast = useToast();
    var simulateUser = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            loginWithCockpit(emailToSimulate)
                .then(function () {
                window.location.href = "/";
            })
                .catch(function (e) {
                toast({
                    status: "error",
                    title: e.response.data.message,
                    duration: 3000,
                    isClosable: true,
                });
            })
                .finally(function () {
                setLoading(false);
            });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        setEmailToSimulate("");
        setIsAccepeted(false);
    }, [isOpen]);
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, size: "lg" },
        React.createElement(ModalOverlay, null,
            React.createElement(ModalContent, { minH: 400 },
                React.createElement(ModalHeader, { fontSize: "lg", fontWeight: "bold" }, "Enter cockpit"),
                React.createElement(ModalCloseButton, null),
                React.createElement(ModalBody, { fontSize: "lg" },
                    loading && (React.createElement(Center, { py: "18" },
                        React.createElement(Spinner, { color: "blue.500" }))),
                    !loading && (React.createElement(React.Fragment, null,
                        React.createElement(VStack, { gridGap: "1", w: "full", alignItems: "flex-start" },
                            React.createElement(Text, { color: "black.800", fontSize: "md" }, "Are you sure you want to enter cockpit?"),
                            React.createElement(Stack, { direction: "row" },
                                React.createElement(Alert, { borderRadius: "5px", status: "warning", variant: "subtle", flexDirection: "row", textAlign: "left", alignItems: "initial" },
                                    React.createElement(Box, null,
                                        React.createElement(AlertIcon, { boxSize: "20px", mr: 0 })),
                                    React.createElement(Box, null,
                                        React.createElement(AlertTitle, { marginLeft: 5, fontSize: "md" }, "Attention"),
                                        React.createElement(HStack, { marginLeft: 5, fontSize: "md" },
                                            React.createElement(AlertDescription, null, "Your actions will be registered. Please be mindful while doing it."))))),
                            React.createElement(FormControl, { flex: "1" },
                                React.createElement(FormLabel, { fontSize: "md", fontWeight: "500", color: "gray.800" }, "User email"),
                                React.createElement(Input, { autoComplete: "off", type: "email", name: "email", defaultValue: emailToSimulate, placeholder: "name@email.com", onChange: function (e) { return setEmailToSimulate(e.target.value); } })),
                            React.createElement(FormControl, { flex: "1", pt: 2 },
                                React.createElement(Checkbox, { isChecked: isAccepeted, onChange: function () { return setIsAccepeted(!isAccepeted); } }, "Yes, I want to enter cockpit")))))),
                React.createElement(ModalFooter, null,
                    React.createElement(HStack, { spacing: 3, marginTop: 5 },
                        React.createElement(Button, { type: "submit", disabled: !isAccepeted || !!loading, colorScheme: "blue", bg: "blue.500", onClick: simulateUser }, "Continue"),
                        React.createElement(Button, { onClick: onClose }, "Cancel")))))));
};
